import { library, findIconDefinition } from '@fortawesome/fontawesome-svg-core'
import usedIcons from './icons'
import * as kitCustomIcons from '@awesome.me/kit-056688db4a/icons/modules/kit/custom.mjs'

// icons used in the source (generated by scripts/fontawesome/generate-icons.js) and the custom kit icons
library.add(...usedIcons, ...Object.values(kitCustomIcons))

// full packs, loaded on demand only when an icon is not registered (e.g. an icon name that comes from the API)
const packLoaders = {
  fal: () => import(/* webpackChunkName: "fa-light" */ '@fortawesome/pro-light-svg-icons'),
  fas: () => import(/* webpackChunkName: "fa-solid" */ '@fortawesome/pro-solid-svg-icons'),
  fad: () => import(/* webpackChunkName: "fa-duotone" */ '@fortawesome/pro-duotone-svg-icons'),
  far: () => import(/* webpackChunkName: "fa-regular" */ '@awesome.me/kit-056688db4a/icons/modules/classic/regular.mjs')
}
const loadingPacks = {}

export function hasIcon (prefix, iconName) {
  return !!findIconDefinition({ prefix, iconName })
}

// resolves true when the icon could be registered from its full pack
export function loadMissingIcon (prefix, iconName) {
  if (!packLoaders[prefix]) return Promise.resolve(false)
  if (!loadingPacks[prefix]) {
    loadingPacks[prefix] = packLoaders[prefix]().then(pack => {
      library.add(...Object.keys(pack)
        .filter(key => key.startsWith('fa') && pack[key] && pack[key].iconName)
        .map(key => pack[key]))
    })
  }
  return loadingPacks[prefix].then(() => {
    const found = hasIcon(prefix, iconName)
    if (found && process.env.NODE_ENV !== 'production') {
      console.warn(`[fontawesome] "${prefix} ${iconName}" was loaded lazily; add it to EXTRA_ICONS in scripts/fontawesome/generate-icons.js if it is used often`)
    }
    return found
  })
}
